 export const predictHeight = (data) => {
   return {
    type: 'PREDICT_HEIGHT',
    payload: data
  }
 }
